/* KYRIOS — interactividad de secciones (announce bar, header, tabs, etc.) */

(function () {
  'use strict';

  /* ============ Helpers ============ */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ============ Barra de anuncios: rotación CSS/JS ============ */
  function initAnnounceBar() {
    const bar = qs('.kyrios-announce');
    if (!bar) return;
    const items = qsa('.k-ann-msg', bar);
    if (items.length <= 1) return;
    let idx = 0;
    items.forEach((el, i) => { el.style.display = i === 0 ? 'flex' : 'none'; });
    setInterval(() => {
      items[idx].style.display = 'none';
      idx = (idx + 1) % items.length;
      items[idx].style.display = 'flex';
      items[idx].style.animation = 'none';
      items[idx].offsetHeight; // reflow
      items[idx].style.animation = '';
    }, 4000);
  }

  /* ============ Header: menú móvil ============ */
  function initMobileNav() {
    const burger = qs('.k-hdr-burger');
    const mnav = qs('.kyrios-mnav');
    const close = qs('.k-mnav-close', mnav);
    if (!burger || !mnav) return;

    burger.addEventListener('click', () => mnav.classList.add('is-open'));
    if (close) close.addEventListener('click', () => mnav.classList.remove('is-open'));
    mnav.addEventListener('click', (e) => { if (e.target === mnav) mnav.classList.remove('is-open'); });

    // Submenús móviles
    qsa('.k-mnav-exp', mnav).forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.classList.toggle('is-on');
        const sub = btn.closest('.k-mnav-row').nextElementSibling;
        if (sub && sub.classList.contains('k-mnav-sub')) {
          sub.style.display = sub.style.display === 'none' ? 'flex' : 'none';
        }
      });
    });
    // Inicializar submenús ocultos
    qsa('.k-mnav-sub', mnav).forEach((sub) => { sub.style.display = 'none'; });
  }

  /* ============ Header: buscador móvil (lupa) ============ */
  function initHeaderSearch() {
    const toggle = qs('.k-hdr-search-toggle');
    const bar = qs('#kyrios-msearch');
    if (!toggle || !bar) return;
    const input = qs('input[type="search"]', bar);

    function open() {
      bar.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      if (input) input.focus();
    }
    function closeBar() {
      bar.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', () => { bar.hidden ? open() : closeBar(); });
    if (input) input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { closeBar(); toggle.focus(); }
    });
  }

  /* ============ Header: megamenú (paneles fuera del li) ============ */
  function initMegaMenu() {
    const hdr = qs('.kyrios-hdr');
    if (!hdr) return;
    const nav = qs('.k-nav', hdr);
    if (!nav) return;

    let closeTimer = null;
    let openLi = null;

    /* Botón "Categorías" y su panel — declarados aquí para que closeNow los alcance */
    const allBtn   = qs('.k-navpill-all[aria-controls]', hdr);
    const allPanel = allBtn ? document.getElementById(allBtn.getAttribute('aria-controls')) : null;

    function getBtn(li)   { return li.querySelector('button[aria-controls]'); }
    function getPanel(li) { const b = getBtn(li); return b ? document.getElementById(b.getAttribute('aria-controls')) : null; }

    function _closeAllPanel() {
      if (!allPanel || !allPanel.classList.contains('is-open')) return;
      allPanel.classList.remove('is-open');
      allPanel.setAttribute('aria-hidden', 'true');
      if (allBtn) allBtn.setAttribute('aria-expanded', 'false');
    }

    function openPanel(li) {
      if (openLi && openLi !== li) closeNow();
      if (openLi === li) return;
      _closeAllPanel();
      openLi = li;
      const btn = getBtn(li), panel = getPanel(li);
      li.classList.add('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) { panel.classList.add('is-open'); panel.removeAttribute('aria-hidden'); }
    }

    function closeNow() {
      if (openLi) {
        const btn = getBtn(openLi), panel = getPanel(openLi);
        openLi.classList.remove('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (panel) { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); }
        openLi = null;
      }
      _closeAllPanel();
    }

    function scheduleClose(ms) { clearTimeout(closeTimer); closeTimer = setTimeout(closeNow, ms); }
    function cancelClose()     { clearTimeout(closeTimer); }

    /* Init ARIA */
    const megaLis = qsa('.k-navlist > li.k-has-mega', hdr);
    megaLis.forEach((li) => { const p = getPanel(li); if (p) p.setAttribute('aria-hidden', 'true'); });
    if (allPanel) allPanel.setAttribute('aria-hidden', 'true');

    megaLis.forEach((li) => {
      const btn = getBtn(li), panel = getPanel(li);

      /* hover intent: 120ms abrir, 150ms cerrar */
      li.addEventListener('mouseenter', () => { cancelClose(); clearTimeout(li._ot); li._ot = setTimeout(() => openPanel(li), 120); });
      li.addEventListener('mouseleave', () => { clearTimeout(li._ot); scheduleClose(150); });
      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', () => scheduleClose(150));
      }

      /* teclado en botón trigger */
      if (btn) btn.addEventListener('keydown', (e) => {
        const idx = megaLis.indexOf(li);
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault(); openPanel(li);
          const first = panel && panel.querySelector('a[href], button:not([aria-controls])');
          if (first) first.focus();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault(); closeNow();
          const nb = megaLis[idx + 1]; if (nb) (getBtn(nb) || nb.querySelector('a'))?.focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault(); closeNow();
          const pb = megaLis[idx - 1]; if (pb) (getBtn(pb) || pb.querySelector('a'))?.focus();
        } else if (e.key === 'Escape') { e.preventDefault(); closeNow(); }
      });

      /* teclado dentro del panel */
      if (panel) panel.addEventListener('keydown', (e) => {
        const links = qsa('a[href], button:not([aria-controls])', panel).filter(el => el.offsetParent !== null);
        const cur = document.activeElement, idx = links.indexOf(cur);
        if (e.key === 'ArrowDown')  { e.preventDefault(); (links[idx + 1] || links[0])?.focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (links[idx - 1] || links[links.length - 1])?.focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); closeNow(); btn?.focus(); }
        else if (e.key === 'Tab' && !e.shiftKey && idx === links.length - 1) { closeNow(); }
      });
    });

    /* ── k-navpill-all: toggle del panel de todas las categorías ── */
    if (allBtn && allPanel) {
      function openAllPanel() {
        if (openLi) closeNow();
        allPanel.classList.add('is-open');
        allPanel.removeAttribute('aria-hidden');
        allBtn.setAttribute('aria-expanded', 'true');
      }

      /* click: toggle */
      allBtn.addEventListener('click', () => {
        cancelClose();
        allPanel.classList.contains('is-open') ? _closeAllPanel() : openAllPanel();
      });

      /* hover intent */
      allBtn.addEventListener('mouseenter', () => {
        cancelClose(); clearTimeout(allBtn._ot);
        allBtn._ot = setTimeout(openAllPanel, 120);
      });
      allBtn.addEventListener('mouseleave', () => { clearTimeout(allBtn._ot); scheduleClose(150); });
      allPanel.addEventListener('mouseenter', cancelClose);
      allPanel.addEventListener('mouseleave', () => scheduleClose(150));

      /* teclado en botón */
      allBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault(); openAllPanel();
          const first = allPanel.querySelector('a[href]');
          if (first) first.focus();
        }
        if (e.key === 'Escape') { e.preventDefault(); _closeAllPanel(); allBtn.focus(); }
      });

      /* teclado dentro del panel */
      allPanel.addEventListener('keydown', (e) => {
        const links = qsa('a[href]', allPanel).filter(el => el.offsetParent !== null);
        const cur = document.activeElement, idx = links.indexOf(cur);
        if (e.key === 'ArrowDown') { e.preventDefault(); (links[idx + 1] || links[0])?.focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (links[idx - 1] || links[links.length - 1])?.focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); _closeAllPanel(); allBtn.focus(); }
      });
    }

    /* click fuera y scroll — closeNow() ya cierra todo (li + allPanel) */
    document.addEventListener('click', (e) => {
      if ((openLi || allPanel?.classList.contains('is-open')) && !nav.contains(e.target)) closeNow();
    });
    window.addEventListener('scroll', () => {
      if (openLi || allPanel?.classList.contains('is-open')) closeNow();
    }, { passive: true });
  }

  /* ============ PDP: tabs ============ */
  function initPdpTabs() {
    qsa('.kyrios-pdp').forEach((pdp) => {
      const tabs = qsa('.k-pdp-tab', pdp);
      const bodies = qsa('.k-pdp-tabbody-panel', pdp);
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
          bodies.forEach((b) => b.style.display = 'none');
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          if (bodies[i]) { bodies[i].style.display = 'block'; bodies[i].classList.add('k-rise'); }
        });
      });
    });
  }

  /* ============ PDP: sticky buy bar ============ */
  function initStickyBar() {
    const bar = qs('.k-stickybar');
    const ref = qs('.k-pdp-buybox');
    if (!bar || !ref) return;
    const onScroll = () => {
      const show = ref.getBoundingClientRect().bottom < 60;
      bar.classList.toggle('is-show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ============ PDP: galería de miniaturas ============ */
  function initGallery() {
    qsa('.kyrios-pdp').forEach((pdp) => {
      const thumbs = qsa('.k-pdp-thumb', pdp);
      const stage = qs('.k-pdp-stage-img', pdp);
      const stageBox = qs('.k-pdp-stage', pdp);
      const prevBtn = qs('.k-pdp-arrow--prev', pdp);
      const nextBtn = qs('.k-pdp-arrow--next', pdp);

      function activate(thumb) {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (stage && thumb.dataset.src) {
          stage.src = thumb.dataset.src;
          if (thumb.dataset.srcset) stage.srcset = thumb.dataset.srcset;
          // Propaga la fuente de alta resolución y dimensiones nativas para el zoom
          if (thumb.dataset.zoomSrc) stage.dataset.zoomSrc = thumb.dataset.zoomSrc;
          if (thumb.dataset.nativeW) stage.dataset.nativeW = thumb.dataset.nativeW;
          if (thumb.dataset.nativeH) stage.dataset.nativeH = thumb.dataset.nativeH;
          // Notifica al módulo de zoom (resetea a 1x y recalcula disponibilidad)
          stage.dispatchEvent(new CustomEvent('k-media-change'));
        }
      }
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => activate(thumb));
        thumb.addEventListener('mouseenter', () => activate(thumb));
      });

      // Flechas prev/next: navegan las fotos hacia los lados (cíclico)
      function step(dir) {
        if (thumbs.length < 2) return;
        let i = thumbs.findIndex((t) => t.classList.contains('is-active'));
        if (i < 0) i = 0;
        activate(thumbs[(i + dir + thumbs.length) % thumbs.length]);
      }
      if (thumbs.length < 2) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
      } else {
        if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); step(-1); });
        if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); step(1); });
        // Teclado en el stage (bloqueado mientras hay zoom activo)
        if (stageBox) {
          stageBox.addEventListener('keydown', (e) => {
            if (stageBox.classList.contains('is-zoomed')) return;
            if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
            else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
          });
        }
      }
    });
  }

  /* ============ PDP: anexa el producto a los motivos WhatsApp "por un producto" ============ */
  function initPdpWhatsApp() {
    const pdp = qs('.kyrios-pdp');
    if (!pdp) return;
    const titleEl = qs('.k-pdp-title', pdp);
    const title = titleEl ? titleEl.textContent.trim() : '';
    if (!title) return;
    const waWrap = qs('.k-wa');
    const num = (waWrap && waWrap.dataset.waNum) || '56926234982';
    const url = location.origin + location.pathname;
    // En páginas de producto, los motivos marcados "producto" incluyen el producto actual.
    qsa('.k-wa [data-wa-product]').forEach((a) => {
      const base = (a.dataset.waMsg || '').replace(/[\s.:]*$/, '');
      const msg = base + ': ' + title + '\n' + url;
      a.setAttribute('href', 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg));
    });
  }

  /* ============ PDP: zoom experto de la galería ============ */
  function initProductZoom() {
    const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const clamp = (v, a, b) => (v < a ? a : (v > b ? b : v));

    qsa('.kyrios-pdp').forEach((pdp) => {
      const stage = qs('.k-pdp-stage', pdp);
      const img = qs('.k-pdp-stage-img', pdp);
      if (!stage || !img) return;
      const hint = qs('.k-pdp-zoom-hint', stage);
      const live = qs('.k-pdp-zoom-live', stage);

      const MAX = 3;                 // factor de zoom máximo (cap)
      let available = false, zoomed = false;
      let scale = 1, tx = 0, ty = 0, maxFactor = 1;
      const preloaded = new Set();

      // Rectángulo dibujado (object-fit:contain dentro del content-box con padding)
      function renderedW() {
        const cs = getComputedStyle(img);
        const bw = img.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        const bh = img.clientHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
        const nw = parseFloat(img.dataset.nativeW) || 0, nh = parseFloat(img.dataset.nativeH) || 0;
        if (!nw || !nh || bw <= 0 || bh <= 0) return bw;
        const ar = nw / nh;
        return (ar > bw / bh) ? bw : bh * ar;   // ancho dibujado real
      }
      // Regla clave: solo hay zoom si la foto nativa da 1.5x sobre lo renderizado
      function evalAvail() {
        const nw = parseFloat(img.dataset.nativeW) || 0;
        const rw = renderedW();
        available = !!img.dataset.zoomSrc && rw > 0 && nw >= rw * 1.5;
        maxFactor = available ? Math.min(MAX, nw / rw) : 1;
        if (!zoomed) {
          stage.classList.toggle('is-zoom-available', available);
          if (hint) hint.hidden = !available;
        }
      }

      function boxWH() { return { W: img.clientWidth, H: img.clientHeight }; }
      function clampPan() {
        const { W, H } = boxWH();
        tx = clamp(tx, -(scale - 1) * W, 0);
        ty = clamp(ty, -(scale - 1) * H, 0);
      }
      function panFraction(px, py) {
        const { W, H } = boxWH();
        tx = -(scale - 1) * W * clamp(px, 0, 1);
        ty = -(scale - 1) * H * clamp(py, 0, 1);
        clampPan();
      }
      // Fracción 0..1 usando el rect ESTABLE del stage (no el img transformado)
      function frac(cx, cy) {
        const r = stage.getBoundingClientRect();
        return { px: clamp((cx - r.left) / r.width, 0, 1), py: clamp((cy - r.top) / r.height, 0, 1) };
      }

      let raf = false;
      function draw(anim) {
        const soft = anim && !reduce();
        img.style.transformOrigin = '0 0';
        img.style.transition = soft ? 'transform .18s ease' : 'none';
        img.style.transform = zoomed ? 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')' : '';
        if (soft) window.setTimeout(() => { img.style.transition = 'none'; }, 200);
      }
      function drawRAF() {
        if (raf) return;
        raf = true;
        window.requestAnimationFrame(() => { raf = false; draw(false); });
      }
      function preload() {
        const s = img.dataset.zoomSrc;
        if (s && !preloaded.has(s)) { const im = new Image(); im.src = s; preloaded.add(s); }
      }
      function say(m) { if (live) live.textContent = m; }
      // Integración defensiva con flechas prev/next si existieran
      function arrows(hide) {
        qsa('.k-pdp-stage [data-gal-nav], .k-pdp-arrow, .k-gal-arrow, .k-pdp-stage-nav, [data-stage-nav]', pdp)
          .forEach((a) => { a.style.visibility = hide ? 'hidden' : ''; });
      }
      function useHiRes() {
        if (img.dataset.zoomSrc && img.getAttribute('src') !== img.dataset.zoomSrc) {
          img.removeAttribute('srcset');
          img.src = img.dataset.zoomSrc;
        }
      }

      function enter(px, py, factor) {
        if (!available) return;
        scale = clamp(factor || maxFactor, 1, maxFactor);
        useHiRes();
        zoomed = true;
        stage.classList.add('is-zoomed');
        stage.classList.remove('is-zoom-available');
        if (hint) hint.hidden = true;
        arrows(true);
        panFraction(px, py);
        draw(true);
        say('Zoom activado.');
      }
      function exit() {
        if (!zoomed) { evalAvail(); return; }
        zoomed = false; scale = 1; tx = 0; ty = 0;
        stage.classList.remove('is-zoomed');
        draw(true);
        arrows(false);
        evalAvail();
        say('Zoom desactivado.');
      }

      /* ---- Desktop: hover pre-carga, click entra/sale, mousemove panea ---- */
      if (canHover) {
        stage.addEventListener('mouseenter', () => { if (available) preload(); });
        stage.addEventListener('click', (e) => {
          if (e.target.closest('.k-pdp-fav') || e.target.closest('.k-pdp-stage-badges')) return;
          if (zoomed) { exit(); }
          else if (available) { const f = frac(e.clientX, e.clientY); enter(f.px, f.py, maxFactor); }
        });
        stage.addEventListener('mousemove', (e) => {
          if (!zoomed) return;
          const f = frac(e.clientX, e.clientY);
          panFraction(f.px, f.py);
          drawRAF();
        });
      }

      /* ---- Móvil: pinch + doble tap + arrastre (Pointer Events) ---- */
      const pts = new Map();
      let mode = null, last = null, pinchD0 = 0, pinchS0 = 1;
      let downX = 0, downY = 0, downT = 0, moved = false;
      let lastTap = 0, lastTapX = 0, lastTapY = 0;
      const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

      img.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        try { img.setPointerCapture(e.pointerId); } catch (_) {}
        if (pts.size === 2) {
          const [p1, p2] = [...pts.values()];
          mode = 'pinch'; pinchD0 = dist(p1, p2) || 1; pinchS0 = scale;
        } else if (pts.size === 1) {
          mode = zoomed ? 'drag' : null;
          last = { x: e.clientX, y: e.clientY };
          downX = e.clientX; downY = e.clientY; downT = (window.performance || Date).now(); moved = false;
        }
      });

      img.addEventListener('pointermove', (e) => {
        if (e.pointerType === 'mouse' || !pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (Math.hypot(e.clientX - downX, e.clientY - downY) > 10) moved = true;

        if (mode === 'pinch' && pts.size >= 2) {
          e.preventDefault();
          const [p1, p2] = [...pts.values()];
          const d = dist(p1, p2) || 1;
          const mx = (p1.x + p2.x) / 2, my = (p1.y + p2.y) / 2;
          const ns = clamp(pinchS0 * (d / pinchD0), 1, maxFactor);
          if (available && ns > 1.02) {
            if (!zoomed) { useHiRes(); zoomed = true; stage.classList.add('is-zoomed'); stage.classList.remove('is-zoom-available'); if (hint) hint.hidden = true; arrows(true); say('Zoom activado.'); }
            scale = ns;
            const f = frac(mx, my);
            panFraction(f.px, f.py);
            drawRAF();
          } else if (zoomed) { exit(); }
        } else if (mode === 'drag' && zoomed && last) {
          e.preventDefault();
          tx += e.clientX - last.x; ty += e.clientY - last.y;
          last = { x: e.clientX, y: e.clientY };
          clampPan(); drawRAF();
        }
      });

      function endPointer(e) {
        if (e.pointerType === 'mouse') return;
        pts.delete(e.pointerId);
        try { img.releasePointerCapture(e.pointerId); } catch (_) {}
        if (pts.size === 1) {
          const p = [...pts.values()][0];
          mode = zoomed ? 'drag' : null; last = { x: p.x, y: p.y };
        } else if (pts.size === 0) {
          const now = (window.performance || Date).now();
          if (!moved && (now - downT) < 250) {
            if (now - lastTap < 300 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
              if (zoomed) exit();
              else { const f = frac(e.clientX, e.clientY); enter(f.px, f.py, Math.min(2.5, maxFactor)); }
              lastTap = 0;
            } else { lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY; }
          }
          mode = null; last = null;
        }
      }
      img.addEventListener('pointerup', endPointer);
      img.addEventListener('pointercancel', endPointer);

      /* ---- Escape sale del zoom ---- */
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && zoomed) { e.preventDefault(); exit(); } });

      /* ---- Reset al cambiar de foto + recálculo en load/resize ----
         initGallery despacha el evento sobre el <img> (no burbujea), así que escuchamos ahí. */
      img.addEventListener('k-media-change', () => { exit(); });
      img.addEventListener('load', evalAvail);
      let rt;
      window.addEventListener('resize', () => {
        clearTimeout(rt);
        rt = window.setTimeout(() => { if (zoomed) { clampPan(); draw(false); } evalAvail(); }, 150);
      });
      evalAvail();
    });
  }

  /* ============ PDP: variantes de color + price sync ============ */
  function initVariants() {
    const jsonEl = document.getElementById('k-variants-json');
    const variants = jsonEl
      ? (() => { try { return JSON.parse(jsonEl.textContent); } catch(e) { return []; } })()
      : [];

    const addForm  = document.getElementById('kyrios-add-form');
    const addBtn   = addForm ? addForm.querySelector('[name="add"]') : null;
    const buyBtn   = addForm ? addForm.querySelector('[name="checkout"]') : null;
    const stockEl  = document.getElementById('kyrios-stock');
    const vidInput = document.getElementById('kyrios-variant-id');

    // Habilita/deshabilita compra y refleja el estado de stock.
    function setBuyState(available) {
      [addBtn, buyBtn].forEach((b) => { if (b) b.disabled = !available; });
      if (!stockEl) return;
      if (available) {
        const t = stockEl.dataset.instock || '';
        stockEl.innerHTML = t ? '<i aria-hidden="true"></i>' + t : '';
      } else {
        stockEl.innerHTML = '<span style="color:var(--k-hot);font-weight:500;">Sin stock</span>';
      }
    }

    // Un valor por grupo de opciones, en orden del DOM (= orden de product.options).
    function selectedOptions() {
      return qsa('.k-pdp-swatches').map((w) => {
        const a = qs('.k-swatch.is-active', w);
        return a ? a.dataset.value : null;
      });
    }

    // Busca la variante cuya matriz [option1, option2, option3] coincide EXACTAMENTE.
    function findVariant(sel) {
      if (sel.indexOf(null) !== -1) return null;
      return variants.find((v) =>
        Array.isArray(v.options) &&
        v.options.length === sel.length &&
        v.options.every((o, i) => o === sel[i])
      ) || null;
    }

    function syncVariantPrice() {
      if (!variants.length) return;
      if (!qsa('.k-pdp-swatches').length) return; // producto de una sola variante: nada que sincronizar

      const sel = selectedOptions();
      const v = findVariant(sel);

      // Combinación inexistente: sin compra, sin romper el precio mostrado.
      if (!v) { setBuyState(false); return; }

      // Precio (price_f / compare_f ya vienen en CLP desde Liquid con | money).
      qsa('.k-price-now').forEach((el) => { el.textContent = v.price_f; });
      qsa('.k-price-was').forEach((el) => {
        if (v.has_sale) { el.textContent = v.compare_f; el.hidden = false; }
        else { el.hidden = true; }
      });
      const pctEl = qs('.k-pdp-pct'), saveEl = qs('.k-pdp-save');
      if (pctEl)  { if (v.has_sale) { pctEl.textContent = '-' + v.pct + '%'; pctEl.hidden = false; } else { pctEl.hidden = true; } }
      if (saveEl) { if (v.has_sale) { saveEl.textContent = '↓ Ahorras ' + v.save_f; saveEl.hidden = false; } else { saveEl.hidden = true; } }

      // id de variante que usan "Agregar al carrito" / "Comprar ahora".
      if (vidInput) vidInput.value = v.id;

      // Disponibilidad / stock.
      setBuyState(!!v.available);

      // Refleja ?variant= en la URL sin recargar.
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}

      // Imagen destacada de la variante (si tiene).
      if (v.media_id) {
        const stageImg = document.getElementById('kyrios-stage-img');
        const matchThumb = document.querySelector('.k-pdp-thumb[data-media-id="' + v.media_id + '"]');
        if (matchThumb) {
          matchThumb.click(); // reutiliza el handler de initGallery (mantiene .is-active)
        } else if (stageImg && v.img) {
          stageImg.src = v.img;
          if (v.srcset) stageImg.srcset = v.srcset;
        }
      }
    }

    qsa('.k-pdp-swatches').forEach((wrap) => {
      const swatches = qsa('.k-swatch', wrap);
      const lbl = wrap.closest('.k-pdp-variants')?.querySelector('.k-pdp-lbl b');
      swatches.forEach((sw) => {
        sw.addEventListener('click', () => {
          swatches.forEach((s) => { s.classList.remove('is-active'); s.setAttribute('aria-checked', 'false'); });
          sw.classList.add('is-active');
          sw.setAttribute('aria-checked', 'true');
          if (lbl) lbl.textContent = sw.dataset.value || sw.querySelector('span:last-child')?.textContent || '';
          syncVariantPrice();
        });
      });
    });
  }

  /* ============ PDP: qty buttons ============ */
  function initQty() {
    qsa('.k-qty').forEach((wrap) => {
      const span   = qs('span', wrap);
      const hidden = qs('input[name="quantity"]', wrap);
      const minus  = qs('[data-action="minus"]', wrap);
      const plus   = qs('[data-action="plus"]', wrap);
      if (!span) return;

      function setQty(v) {
        v = Math.max(1, v);
        span.textContent = v;
        if (hidden) hidden.value = v;
        // keep main display and sticky in sync
        const companion = document.getElementById(span.id === 'kyrios-qty-val' ? 'kyrios-sticky-qty' : 'kyrios-qty-val');
        if (companion) companion.textContent = v;
        // sticky has no hidden input — update form field directly
        if (!hidden) { const qi = document.getElementById('kyrios-qty'); if (qi) qi.value = v; }
      }

      const getV = () => parseInt(hidden ? hidden.value : span.textContent, 10) || 1;
      if (minus) minus.addEventListener('click', () => setQty(getV() - 1));
      if (plus)  plus.addEventListener('click',  () => setQty(getV() + 1));
    });
  }

  /* ============ Countdown ============ */
  function initCountdown() {
    qsa('.k-countdown[data-end]').forEach((el) => {
      const end = parseInt(el.dataset.end, 10) * 1000;
      const hEl = el.querySelector('[data-cd="h"]');
      const mEl = el.querySelector('[data-cd="m"]');
      const sEl = el.querySelector('[data-cd="s"]');
      if (!hEl) return;
      const tick = () => {
        const diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const h = Math.floor(diff / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const s = diff % 60;
        const pad = (n) => String(n).padStart(2, '0');
        hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
      };
      tick();
      setInterval(tick, 1000);
    });
    /* fallback: countdown sin data-end => cuenta regresiva libre de 8h */
    qsa('.k-countdown:not([data-end])').forEach((el) => {
      const hEl = el.querySelector('[data-cd="h"]');
      const mEl = el.querySelector('[data-cd="m"]');
      const sEl = el.querySelector('[data-cd="s"]');
      if (!hEl) return;
      let total = 8 * 3600 + 42 * 60 + 17;
      const tick = () => {
        total = total > 0 ? total - 1 : 11 * 3600 + 59 * 60 + 59;
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        const pad = (n) => String(n).padStart(2, '0');
        hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
      };
      setInterval(tick, 1000);
    });
  }

  /* ============ Fast track: flechas ============ */
  function initFastTrack() {
    qsa('.kyrios-fast').forEach((sec) => {
      const track = qs('.k-fast-track', sec);
      const prev = qs('[data-scroll="-1"]', sec);
      const next = qs('[data-scroll="1"]', sec);
      if (!track) return;
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
    });
  }

  /* ============ Brand tabs ============ */
  function initBrandTabs() {
    qsa('.kyrios-brandtabs').forEach((sec) => {
      const tabs = qsa('.k-brandtab', sec);
      const panels = qsa('.k-brandtab-panel', sec);
      const intro = qsa('.k-brandtab-intro', sec);
      const seeAll = qs('#kyrios-brand-see-all', sec);

      function updateSeeAll(tab) {
        if (!seeAll) return;
        seeAll.href = tab.dataset.href || tab.dataset.url || '#';
      }

      if (tabs[0]) updateSeeAll(tabs[0]);

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => t.classList.remove('is-active'));
          panels.forEach((p) => p.style.display = 'none');
          intro.forEach((x) => x.style.display = 'none');
          tab.classList.add('is-active');
          if (panels[i]) panels[i].style.display = 'grid';
          if (intro[i]) intro[i].style.display = 'flex';
          updateSeeAll(tab);
        });
      });
    });
  }

  /* ============ WhatsApp bubble close ============ */
  function initWa() {
    const closeBtn = qs('.k-wa-close');
    const bubble = qs('.k-wa-bubble');
    if (!closeBtn || !bubble) return;
    closeBtn.addEventListener('click', (e) => { e.preventDefault(); bubble.style.display = 'none'; });
  }

  /* ============ Newsletter form ============ */
  function initNewsletter() {
    qsa('.k-news-form').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const ok = form.nextElementSibling;
        if (ok && ok.classList.contains('k-news-ok')) {
          form.style.display = 'none';
          ok.style.display = 'flex';
        }
      });
    });
  }

  /* ============ Filtros: bottom sheet móvil ============ */
  function initFilterSheet() {
    const sheet = qs('.kyrios-filt-sheet');
    const openBtn = qs('.k-col-filt-btn');
    if (!sheet || !openBtn) return;
    openBtn.addEventListener('click', () => sheet.classList.add('is-open'));
    sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.classList.remove('is-open'); });
    const closeBtn = qs('.k-filt-sheet-close', sheet);
    if (closeBtn) closeBtn.addEventListener('click', () => sheet.classList.remove('is-open'));
    const applyBtn = qs('.k-filt-sheet-apply', sheet);
    if (applyBtn) applyBtn.addEventListener('click', () => sheet.classList.remove('is-open'));
  }

  /* ============ Quick-add ============ */
  function initQuickAdd() {
    let modal = document.getElementById('k-qa-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'k-qa-modal';
      modal.className = 'kyrios k-qa-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'k-qa-title');
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = [
        '<div class="k-qa-overlay"></div>',
        '<div class="k-qa-panel">',
          '<div class="k-qa-hdr">',
            '<h3 class="k-qa-title" id="k-qa-title">Selecciona una opción</h3>',
            '<button class="k-qa-close" aria-label="Cerrar">',
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>',
            '</button>',
          '</div>',
          '<div class="k-qa-body" id="k-qa-body"></div>',
          '<div class="k-qa-footer">',
            '<button class="k-btn k-btn--cyan k-btn--lg k-btn--block k-qa-confirm" disabled>Agregar al carrito</button>',
          '</div>',
        '</div>'
      ].join('');
      document.body.appendChild(modal);
    }

    let currentBtn = null;
    let selectedVariantId = null;

    function openModal(data, btn) {
      currentBtn = btn; selectedVariantId = null;
      qs('#k-qa-title', modal).textContent = data.title;
      const confirm = qs('.k-qa-confirm', modal);
      confirm.disabled = true;
      let html = '';
      data.options.forEach(function(opt, oi) {
        const vals = [...new Set(data.variants.map(function(v) { return v['option' + (oi + 1)]; }).filter(Boolean))];
        html += '<div class="k-qa-optgroup"><p class="k-qa-optlabel">' + opt + '</p><div class="k-qa-opts" data-opt="' + (oi + 1) + '">';
        vals.forEach(function(val) {
          const avail = data.variants.some(function(v) { return v['option' + (oi + 1)] === val && v.available; });
          html += '<button class="k-qa-opt' + (avail ? '' : ' k-qa-opt--sold') + '" data-val="' + val.replace(/"/g, '&quot;') + '"' + (avail ? '' : ' disabled') + '>' + val + '</button>';
        });
        html += '</div></div>';
      });
      qs('#k-qa-body', modal).innerHTML = html;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const firstOpt = qs('.k-qa-opt:not([disabled])', modal);
      if (firstOpt) firstOpt.focus();

      const numOpts = data.options.length;
      const sel = {};
      qsa('.k-qa-opt', modal).forEach(function(ob) {
        ob.addEventListener('click', function() {
          const group = ob.closest('.k-qa-opts');
          qsa('.k-qa-opt', group).forEach(function(b) { b.classList.remove('is-active'); });
          ob.classList.add('is-active');
          sel[group.dataset.opt] = ob.dataset.val;
          if (Object.keys(sel).length === numOpts) {
            const match = data.variants.find(function(v) {
              return Object.entries(sel).every(function(kv) { return v['option' + kv[0]] === kv[1]; });
            });
            selectedVariantId = (match && match.available) ? match.id : null;
            confirm.disabled = !selectedVariantId;
          }
        });
      });
      confirm.onclick = function() { if (!selectedVariantId) return; closeModal(); doAdd(selectedVariantId, btn); };
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (currentBtn) currentBtn.focus();
    }

    qs('.k-qa-overlay', modal).addEventListener('click', closeModal);
    qs('.k-qa-close', modal).addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    function updateCartCount(n) {
      const link = qs('.k-hdr-act--cart');
      if (!link) return;
      const ic = qs('.k-hdr-cart-ic', link);
      if (!ic) return;
      let badge = qs('em', ic);
      if (n > 0) {
        if (!badge) { badge = document.createElement('em'); badge.setAttribute('aria-hidden', 'true'); ic.appendChild(badge); }
        badge.textContent = n;
      } else if (badge) {
        badge.remove();
      }
      link.setAttribute('aria-label', 'Carrito (' + n + ' artículos)');
    }

    function doAdd(variantId, btn) {
      const lbl = qs('.k-qa-lbl', btn);
      const ic  = qs('.k-qa-ic', btn);
      const sp  = qs('.k-qa-spin', btn);
      btn.disabled = true;
      if (lbl) lbl.textContent = 'Agregando…';
      if (ic)  ic.style.display = 'none';
      if (sp)  sp.style.display = 'inline-block';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
      .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        if (ic)  ic.style.display = '';
        if (sp)  sp.style.display = 'none';
        if (lbl) lbl.textContent = '✓ Agregado';
        btn.classList.add('k-qa-btn--added');
        setTimeout(function() {
          btn.disabled = false;
          btn.classList.remove('k-qa-btn--added');
          if (lbl) lbl.textContent = 'Agregar';
        }, 1800);
      })
      .catch(function() {
        btn.disabled = false;
        if (ic)  ic.style.display = '';
        if (sp)  sp.style.display = 'none';
        if (lbl) lbl.textContent = 'Agregar';
      });
    }

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.k-qa-btn');
      if (!btn || btn.disabled) return;
      if (btn.dataset.multi === 'true') {
        const dataEl = btn.parentElement.querySelector('.k-qa-data');
        if (!dataEl) {
          const href = btn.closest('.k-card') && btn.closest('.k-card').querySelector('a.k-card__media');
          window.location.href = href ? href.href : '#';
          return;
        }
        try { openModal(JSON.parse(dataEl.textContent), btn); } catch(err) { window.location.href = '#'; }
      } else {
        doAdd(btn.dataset.variantId, btn);
      }
    });
  }

  /* ============ Init ============ */
  function init() {
    initAnnounceBar();
    initMobileNav();
    initHeaderSearch();
    initMegaMenu();
    initPdpTabs();
    initStickyBar();
    initGallery();
    initProductZoom();
    initPdpWhatsApp();
    initVariants();
    initQty();
    initCountdown();
    initFastTrack();
    initBrandTabs();
    initNewsletter();
    initFilterSheet();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
